import { BasketSummarySubjectType } from '@api/api/basket-summary';
import { useQuery } from '@tanstack/react-query';
import {
  fetchAllMentions,
  QUERY_KEY_THEME_MENTIONS,
} from '../services/theme-mentions-service';

export const useThemeMentions = ({
  id,
  subjectType,
}: {
  id: string;
  subjectType: BasketSummarySubjectType;
}) =>
  useQuery({
    queryKey: [QUERY_KEY_THEME_MENTIONS, id, subjectType],
    queryFn: ({ signal }) => fetchAllMentions(id, subjectType, signal),
  });
